import { parseNumber } from '@gonfalon/filters/parseNumber';
import { parseSort } from '@gonfalon/filters/parseSort';

import { parseUIFlagFilterFromBrowser } from './parseUIFlagFilterFromBrowser';
import { sortOrderingSchema, type UIFlagListView } from './types';

export function parseUIFlagListViewFromBrowser(searchParams: URLSearchParams) {
  const ui: UIFlagListView = {};
  ui.offset = parseNumber(searchParams.get('offset'));
  ui.sort = parseSort(sortOrderingSchema, searchParams.get('sort'));
  ui.filter = parseUIFlagFilterFromBrowser(searchParams);
  return ui;
}
